import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios';
import CustomTable from '../../../components/table/SimpleTable'
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, useMediaQuery, IconButton, Paper, CircularProgress } from '@mui/material'
import { ChevronLeft, ChevronRight, NavigateBefore, NavigateNext } from '@mui/icons-material';
import StudentReportComponent from '../../../components/report/student';
import { useDispatch, useSelector } from 'react-redux';
import getImage from '../../../assets/images/webLogo.png'
import './Home.css'

const Home = (props) => {
    const dispatch = useDispatch();
    const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
    const parameter = JSON.parse(localStorage.getItem('User_Data'))?.Descript || undefined;
    const url = `${localStorage.getItem('server')}/apk/showFess`;
    const [data, setData] = useState()
    const [schoolInfo, setSchoolInfo] = useState()
    const [promotions, setPromotions] = useState([])
    const [currentSlide, setCurrentSlide] = useState(0)
    const [slidesToShow, setSlidesToShow] = useState(3)
    const [imageLoaded, setImageLoaded] = useState({})
    const autoPlayRef = useRef()
    // const currentSchool = useSelector((state) => state.Api.currentSchool);
    const [currentSchool, setCurrentSchool] = useState(JSON.parse(localStorage.getItem('selectedSchool')));
    console.log(currentSchool)
    function refreshPage () {
        callAPI()
    }

    function callAPI () {
        dispatch({ type: "SHOW_LOADER", Seconds: "1" });
        axios.post(url, { parameter }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`,
            },
        })
            .then((res) => {
                dispatch({ type: "SHOW_LOADER", Seconds: "0" });
                if (res.status === 200)
                {
                    setData(res.data.data)
                    setSchoolInfo(res?.data?.data[0]?.schoolDetails)
                    // Extract promotions from the response
                    if (res.data.totalPromotions && res.data.totalPromotions.length > 0)
                    {
                        setPromotions(res.data.totalPromotions)
                        // Initialize image loaded state for all students
                        const initialLoadedState = {}
                        res.data.totalPromotions[0].students.forEach(student => {
                            initialLoadedState[student.rollNum] = false
                        })
                        setImageLoaded(initialLoadedState)
                    }
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch({ type: "SHOW_LOADER", Seconds: "0" });
            });
    }

    useEffect(() => {
        callAPI()
    }, [])

    // Responsive slides to show
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 600)
            {
                setSlidesToShow(1)
            } else if (window.innerWidth < 900)
            {
                setSlidesToShow(2)
            } else
            {
                setSlidesToShow(3)
            }
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // Auto-slide functionality
    useEffect(() => {
        if (promotions.length > 0)
        {
            autoPlayRef.current = setInterval(() => {
                nextSlide()
            }, 5000) // Change slide every 5 seconds
        }

        return () => {
            if (autoPlayRef.current)
            {
                clearInterval(autoPlayRef.current)
            }
        }
    }, [promotions, currentSlide])

    const nextSlide = () => {
        if (promotions.length > 0)
        {
            setCurrentSlide((prev) =>
                prev + slidesToShow >= promotions[0]?.students?.length
                    ? 0
                    : prev + slidesToShow
            )
        }
    }

    const prevSlide = () => {
        if (promotions.length > 0)
        {
            setCurrentSlide((prev) =>
                prev - slidesToShow < 0
                    ? Math.max(0, promotions[0]?.students?.length - slidesToShow)
                    : prev - slidesToShow
            )
        }
    }

    // Get current students to display
    const getCurrentStudents = () => {
        if (!promotions[0]?.students) return []
        const start = currentSlide
        const end = Math.min(start + slidesToShow, promotions[0].students.length)
        return promotions[0].students.slice(start, end)
    }

    const handleImageLoad = (rollNum) => {
        setImageLoaded(prev => ({
            ...prev,
            [rollNum]: true
        }))
    }

    return (
        <>
            <Box>
                {/* <Box mt={1} lg={12} justifyContent={'center'} justifyItems={'center'} display={'flex'}>
                    <img src={getImage} alt="logo" width={'80%'} height={'50%'} />
                </Box> */}
                <Box mt={1} lg={12} justifyContent={'center'} justifyItems={'center'} display={'flex'}>

                    <Avatar
                        src={`${currentSchool.backend}/Public/${currentSchool.WebSrn}/${currentSchool.WebSrn}.png`}
                        alt={currentSchool.name}
                        sx={{ width: 130, height: 130 }}

                    />
                    {/* <img  src={`${currentSchool.backend}/Public/${currentSchool.WebSrn}/${currentSchool.WebSrn}.png`} style={{maxWidth:'40%'}} alt="logo"/> */}
                </Box>
            </Box>

            {/* Regular Announcements */}
            {
                data && data?.length > 0 && data[0]?.result?.announcement?.[0]?.Message && (
                    <Box mt={2}>
                        <Grid item lg={12}>
                            <Box className='announce'>
                                {data[0]?.result?.announcement[0]?.Message}
                            </Box>
                        </Grid>
                    </Box>
                )
            }

            {/* Student Records */}
            {
                data && data.map((item, ind) => (
                    <Box display={'flex'} justifyContent={'center'} justifyItems={'center'} alignItems={'center'} key={ind}>
                        <StudentReportComponent data={item.result} />
                    </Box>
                ))
            }


            <br />
            <br />

            {/* Promotions Slider Section */}
            {promotions.length > 0 && promotions[0].students && promotions[0].students.length > 0 && (
                <Box mt={0} mb={0}>
                    <Paper elevation={3} style={{ marginTop: '15px', backgroundColor: '#f5f5f5' }}>
                        {/* Promotion Heading */}
                        <Typography
                            variant="h4"
                            align="center"
                            gutterBottom
                            style={{
                                color: '#ffc60a',
                                fontWeight: 'bold',
                                marginBottom: '0px',
                                marginTop: '15px'
                            }}
                        >
                            {promotions[0].heading}
                        </Typography>

                        {/* Slider Container */}
                        <Box position="relative">
                            {/* Previous Button */}
                            {promotions[0].students.length > slidesToShow && (
                                <IconButton
                                    onClick={prevSlide}
                                    style={{
                                        position: 'absolute',
                                        left: -20,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 2,
                                        backgroundColor: 'white',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                                    }}
                                >
                                    <ChevronLeft />
                                </IconButton>
                            )}

                            {/* Slides Container */}
                            <Box
                                style={{
                                    overflow: 'hidden',
                                    margin: '0px'
                                }}
                            >
                                <Box
                                    style={{
                                        display: 'flex',
                                        transition: 'transform 0.5s ease-in-out',
                                        transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`
                                    }}
                                >
                                    {promotions[0].students.map((student, idx) => (
                                        <Box
                                            key={idx}
                                            style={{
                                                flex: `0 0 calc(${100 / slidesToShow}% - 0px)`,
                                                minWidth: 0,
                                                padding: '0 5px'
                                            }}
                                        >
                                            <Paper
                                                elevation={2}
                                                style={{
                                                    margin: '5px 0px',
                                                    textAlign: 'center',
                                                    backgroundColor: 'white',
                                                    borderRadius: '10px',
                                                    height: '100%',
                                                    transition: 'transform 0.3s',
                                                    cursor: 'pointer',
                                                    overflow: 'hidden'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)'
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)'
                                                }}
                                            >
                                                {/* Image Container with Loading State */}
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    position="relative"
                                                    style={{
                                                        minHeight: '220px',
                                                        backgroundColor: '#ffffff'
                                                    }}
                                                >
                                                    {!imageLoaded[student.rollNum] && (
                                                        <Box
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                zIndex: 1
                                                            }}
                                                        >
                                                            <CircularProgress size={40} />
                                                        </Box>
                                                    )}

                                                    <img
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '220px',
                                                            height: '220px',
                                                            objectFit: 'cover',
                                                            borderRadius: '5px',
                                                            opacity: imageLoaded[student.rollNum] ? 1 : 0,
                                                            transition: 'opacity 0.3s ease-in-out'
                                                        }}
                                                        src={student.picture ? parameter?.imageUrl + student.picture : `${parameter?.imageUrl}${localStorage.getItem('WebSrn')}/${localStorage.getItem('WebSrn')}.png`}
                                                        onLoad={() => handleImageLoad(student.rollNum)}
                                                        alt={student.Name_P || student.name}
                                                    />
                                                </Box>

                                                {/* Text Content - Only appears after image loads or with fade-in */}
                                                <Box
                                                    mt={0}
                                                    style={{
                                                        opacity: imageLoaded[student.rollNum] ? 1 : 0,
                                                        transition: 'opacity 0.3s ease-in-out',
                                                        padding: '5px'
                                                    }}
                                                >
                                                    {student.comment && (
                                                        <Typography
                                                            variant="body2"
                                                            style={{
                                                                backgroundColor: '#fdfde3',
                                                                marginTop: '0px',
                                                                zIndex: '1000',
                                                                color: '#ffc60a',
                                                                padding: '0px'
                                                            }}
                                                        >
                                                            <strong style={{ fontSize: '18px' }}>{student.Name_P || student.name || ` ${student.rollNum}`}-{student.rollNum}</strong>
                                                            <br />
                                                            <strong>{student.class}</strong>
                                                            <br />
                                                            <strong style={{ fontSize: '18px' }}>{student.comment}</strong>
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Paper>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>

                            {/* Next Button */}
                            {promotions[0].students.length > slidesToShow && (
                                <IconButton
                                    onClick={nextSlide}
                                    style={{
                                        position: 'absolute',
                                        right: -20,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 2,
                                        backgroundColor: 'white',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                                    }}
                                >
                                    <ChevronRight />
                                </IconButton>
                            )}
                        </Box>
                    </Paper>
                </Box>
            )}

            {/* Footer Section */}
            <Box>
                <Box mt={1} lg={12} justifyContent={'center'} justifyItems={'center'} display={'flex'}>
                    <button className="primary" onClick={refreshPage}>Refresh</button>
                </Box>
                <br />
            </Box>

            <Box display="flex" flexDirection={{ xs: 'column', lg: 'row' }} alignItems="center" justifyContent="center">
                <Box mt={1} lg={12} display="flex" justifyContent="center">
                    <div>
                        <div>Call Us: <a href={`tel:0${schoolInfo?.normalPhone}`}>{schoolInfo?.normalPhone}</a></div>
                        <div>WhatsApp: <a href={`whatsapp://send?phone=+93${schoolInfo?.whatsApp}`}>{schoolInfo?.whatsApp}</a></div>
                    </div>
                </Box>
            </Box>
            <br />
            <br />
            <br />
            <br />
        </>
    )
}

Home.propTypes = {}

export default Home